import type { Release } from '../releases.ts';

export default {
  version: '0.9.2',
  date: '2026-09-30',
  title: 'Editor preview fix',
  summary: [
    'Fixed: graphics and subtitles show above the video in the sequence preview again',
  ],
  features: [],
  fixes: ['Graphics and subtitles show above the video in the sequence preview again'],
} satisfies Release;
